/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'check': {
    width: 16,
    height: 16,
    viewBox: '0 0 56.36 34.8',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M27.54 28.82l-4.79 4.79a2.35 2.35 0 0 1-3.32 0L.35 14.54M56 .35l-25.89 25.9"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/check.js